var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layoutContainer',[_c('h4',{staticClass:"aboutTitle"},[_vm._v(_vm._s(_vm.baseData.title))]),_c('div',{staticClass:"aboutText",domProps:{"innerHTML":_vm._s(_vm.baseData.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }